import type { EventId, MyBet } from '@ps/isp-web-services-types';

import { EventTypeId } from '@swf/sports/types/eventType';

const eventTypeIdIsValid = (eventTypeId: number): eventTypeId is EventTypeId =>
  Object.values(EventTypeId).includes(eventTypeId);

const groupEventsBySportType = (
  groupedEventsAccumulator: Partial<Record<EventTypeId, EventId[]>>,
  [sportId, eventId]: (string | undefined)[]
) => {
  const eventTypeId = Number(sportId);
  const eventIdAsNumber = Number(eventId);

  if (!sportId || !eventId || !eventTypeIdIsValid(eventTypeId)) {
    return groupedEventsAccumulator;
  }

  const eventIdList = groupedEventsAccumulator[eventTypeId];
  const shouldAddEventToList = !eventIdList?.includes(eventIdAsNumber);

  if (shouldAddEventToList) {
    groupedEventsAccumulator[eventTypeId] = eventIdList
      ? [...eventIdList, eventIdAsNumber]
      : [eventIdAsNumber];
  }

  return groupedEventsAccumulator;
};

const inPlayPartsWithSportAndEventId = (bet: MyBet) =>
  bet.legs.flatMap((leg) => leg.parts.map((part) => [part.sportId, part.eventId])).flat();

const inPlay = (bet: MyBet) => bet.legs.find((leg) => leg.parts.find((parts) => parts.inPlay));

const openBets = (bet: MyBet) => !bet.isSettled;

export const getEventTypesWithEventIds = (bets: MyBet[]) =>
  bets
    .filter(openBets)
    .filter(inPlay)
    .map(inPlayPartsWithSportAndEventId)
    .reduce(groupEventsBySportType, {});
